import { isValidNumber } from "@pineapplelab/util";

export class FileUtils {

	static isVideo(file: File): boolean {
		return file.type.startsWith('video');
	}

	static isPDF(file: File): boolean {
		return file.type.includes('pdf');
	}

	static getMB(file: File): number {
		return file?.size / (1024 * 1024);
	}

	static getVideoThumbnail(file: File, aSecond: number = 1): Promise<{ thumbnail: string, thumbnailFile: File | null, duration: number }> {
		return new Promise((resolve) => {
			const video = document.createElement('video');
			video.src = URL.createObjectURL(file);
			video.crossOrigin = 'anonymous';

			const canvas = document.createElement('canvas');
			const context = canvas.getContext('2d');

			video.addEventListener('loadedmetadata', () => {
				const duration = video.duration;
				if (isNaN(video?.duration) || !isValidNumber(video?.duration)) {
					video.currentTime = 0;
				} else {
					video.currentTime = video.duration >= 1 ? aSecond : (aSecond / 2);
				}

				video.addEventListener('seeked', () => {
					if (context) {
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						context.drawImage(video, 0, 0, canvas.width, canvas.height);
						canvas.toBlob((blob) => {
							if (blob) {
								const thumbnailUrl = URL.createObjectURL(blob);
								const thumbnailFile = new File([blob], 'thumbnail.png', { type: 'image/png' });
								URL.revokeObjectURL(video.src);
								resolve({thumbnail: thumbnailUrl, thumbnailFile: thumbnailFile, duration });
							} else {
								resolve({thumbnail:null, thumbnailFile: null, duration });
							}
						}, 'image/png');
					} else {
						resolve({thumbnail:null, thumbnailFile: null, duration });
					}
				}, { once: true });
			}, { once: true });

			video.load();
		});
	}

}
